import React from "react";
import ICON_DATA from "./iconData";

// Icônes de la maquette, embarquées plutôt que chargées depuis l'API Iconify au
// runtime. Le contenu vient de iconData.js, figé et relu : rien n'y provient
// d'une saisie utilisateur.
export default function Icon({ name, size = 20, className = "", ...rest }) {
  const icon = ICON_DATA[name];
  if (!icon) return null;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={icon.viewBox}
      width={size}
      height={size}
      className={`shrink-0 ${className}`}
      aria-hidden="true"
      focusable="false"
      dangerouslySetInnerHTML={{ __html: icon.body }}
      {...rest}
    />
  );
}
